<div class="scrollimation">
    @defer {
        <finder-lottie
            [data]="data"
            [playback]="playbackTrigger"
            (reference)="getReference($event)"
        ></finder-lottie>
    }
</div>
